import { HttpStatusCode } from '@/fetch/core/constant';
import { buildURL } from '@/fetch/core/util';
import { LOGIN_OUT } from '@/redux/actions/common';
import { sendHttpRequest } from '@/redux/fetchHandler';
import { sendGlobalEvent } from '@/utils/emit';
import { message } from 'antd';

let timeCode: any = null;
export const getCookie = (name: string) => {
  if (!name) {
    return '';
  }
  const strCookie = document.cookie;
  const arrCookie = strCookie.split('; ');
  for (let i = 0; i < arrCookie.length; i++) {
    const arr = arrCookie[i].split('=');
    if (name == arr[0]) {
      return arr[1];
    }
  }
  return '';
};
export const clearCookie = (name: string) => {
  const d = new Date();
  d.setTime(d.getTime() + -1 * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
  document.cookie = name + '=' + '' + '; ' + expires;
};
export const trainCodeStatus = () => {
  if (timeCode) return;
  timeCode = setInterval(() => {
    checkQrcode();
  }, 1000);
};

export const clearCheckQrcodeInterval = () => {
  timeCode && clearInterval(timeCode);
};
/*
 定时轮询二维码是否被app扫描
*/
export const checkQrcode = () => {
  const url = buildURL({
    absoluteURL: `https://qr.jdl.cn/check`,
    urlParams: {
      appid: '1673',
      callback: 'handleCallback',
      token: getCookie('wlfstk_smdl'),
      _: new Date().getTime(),
    },
  });
  $.ajax({
    url: url,
    dataType: 'jsonp',
    headers: {
      QRCodeKey: getCookie('QRCodeKey'),
    },
  });
};

/*
  轮询二维码回调函数
  二维码状态：
  code: 200 授权登录
  code: 201 "二维码未扫描，请扫描二维码"
  code: 202 "请手机客户端确认登录"
  code: 203 '二维码无效'
  code: 205  '二维码已取消授权'
*/
(window as any).handleCallback = (resp: any) => {
  sendGlobalEvent('checkQRCode', { result: resp });
  if (resp.code == 200) {
    clearInterval(timeCode);
    timeCode = null;

    //  请求passport写登录态cookie的地址
    const url = 'https://ssa.jdl.cn/sso/redirect';
    const baseURL = location.protocol + '//' + process.env.JDX_APP_JDX_COCKPIT;
    const encodeUrl = encodeURIComponent(encodeURIComponent(baseURL));
    document.cookie = `BakReturnUrl=${encodeUrl}; path=/; domain=.jdl.cn`;
    // document.cookie = "specifiedDomain=.jdl.cn; path=/; domain=.jdl.cn";
    // document.cookie = `ReturnUrl=null; path=/; domain=.sso.jdl.cn; expires=${new Date(0).toUTCString()}`;
    const buildPassportUrl = buildURL({
      absoluteURL:
        'https://passport.jd.com/uc/qrCodeTicketValidation?sso=1&source=jdxmonitor_pc',
      urlParams: {
        t: resp.ticket,
        ReturnUrl: url,
        callback: 'callback',
      },
    });
    $.ajax({
      url: buildPassportUrl,
      dataType: 'jsonp',
      header: {
        QRCodeKey: getCookie('QRCodeKey'),
      },
    });
  }
};

/**
 * setCookie 将thor从jd.com写到jdl.cn
 * @param {any} resp
 */
(window as any).callback = (resp: any) => {
  window.location.assign(resp.url);
  // window.location.href = resp.url;
};

// 退出登录
export const passportExit = () => {
  localStorage.setItem('reload', 'false');
  document.cookie = `ReturnUrl=0; path=/; domain=.jdl.cn expires=${new Date(
    0
  ).toUTCString()}`;
  // 退出集团passport登录
  $.ajax({
    url: 'https://ssa.jdl.cn/exit',
    dataType: 'jsonp',
    success: (resp: any) => {
      const response = JSON.parse(resp);
      if (response.result === 'success') {
        window.location.replace('/login');
      }
    },
  });
};
